import React from 'react';
import { SidebarProvider, useSidebar } from "../context/SidebarContext";
import { Outlet } from "react-router";
import Home from '../pages/Dashboard/Home';

const LayoutContent: React.FC = () => {
    const { isMobileOpen, isCartbarOpen } = useSidebar();


    return (
        // The main container now needs to be a flex column to push the footer down
        <div className="min-h-screen flex flex-col bg-blue-light-15 dark:bg-gray-900 text-theme-xxs">
            <Home />
        </div>
    );
};

const AppLayout: React.FC = () => {
    return (
        <SidebarProvider>
            <LayoutContent />
        </SidebarProvider>
    );
};

export default AppLayout;